export { default } from "./badge.svelte";
